import React, { createContext, useContext, useEffect, useState } from 'react';

import general from '../services/general';

import { NETWORK } from 'constants/index';
import { useReserveValues } from 'hooks/farmingFunction';
import useWalletContext from 'hooks/useWalletContext';

const PriceContext = createContext();
export const usePriceContext = () => useContext(PriceContext);

export const PriceProvider = ({ children }) => {
  const { storedChain } = useWalletContext();
  const [ethPrice, setEthPrice] = useState();
  const [nrgPrice, setNrgPrice] = useState();
  const [apePrice, setApePrice] = useState();
  const [beraPrice, setBeraPrice] = useState();
  const [bonePrice, setBonePrice] = useState();
  const [monPrice, setMonPrice] = useState();
  const [coinPrice, setCoinPrice] = useState(0);
  const [ethPerGmi] = useReserveValues();

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const symbol = NETWORK[storedChain].symbol;
        const prices = await general.prices();

        if (prices) {
          // Handle Soneium, Base, Abstract, TEN, and Monad networks separately since they use ETH/MON but need specific handling
          const isOnSoneium = storedChain === 1868 || storedChain === 1946; // Soneium mainnet and testnet
          const isOnBase = storedChain === 8453 || storedChain === 84532; // Base mainnet and testnet
          const isOnAbstract = storedChain === 2741 || storedChain === 11124; // Abstract mainnet and testnet
          const isOnTen = storedChain === 443; // TEN testnet (TODO: add mainnet when available)

          if (isOnSoneium) {
            setEthPrice(prices.ethereum);
            setCoinPrice(prices.ethereum);
          } else if (isOnBase) {
            setEthPrice(prices.ethereum);
            setCoinPrice(prices.ethereum);
          } else if (isOnAbstract) {
            setEthPrice(prices.ethereum);
            setCoinPrice(prices.ethereum);
          } else if (isOnTen) {
            setEthPrice(prices.ethereum);
            setCoinPrice(prices.ethereum);
          } else {
            switch (symbol) {
              case 'ETH':
                setEthPrice(prices.ethereum);
                setNrgPrice(prices.energi);
                setCoinPrice(prices.ethereum);
                break;
              case 'APE':
                setApePrice(prices['ape-on-apechain']);
                setCoinPrice(prices['ape-on-apechain']);
                break;
              case 'BERA':
                setBeraPrice(prices['berachain-bera']);
                setCoinPrice(prices['berachain-bera']);
                break;
              case 'BONE':
                setBonePrice(prices['bone-shibaswap']);
                setCoinPrice(prices['bone-shibaswap']);
                break;
              case 'MON':
                setMonPrice(prices.monad);
                setCoinPrice(prices.monad);
                break;
              case 'NRG':
              default:
                setNrgPrice(prices.energi);
                setCoinPrice(prices.energi);
                break;
            }
          }
        }
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };

    fetchPrice();
  }, [storedChain]);

  // Calculate GMI price with fallback
  const calculateGmiPrice = () => {
    // If we have valid reserve values, use them
    if (ethPerGmi && ethPerGmi > 0 && ethPrice) {
      return ethPrice * ethPerGmi;
    }

    // Fallback: Use a reasonable GMI price estimate
    // Based on the original hardcoded value in useBondData.js
    return 0.001; // $0.001 per GMI token
  };

  const gmiPrice = calculateGmiPrice();

  return (
    <PriceContext.Provider
      value={{
        ethPrice,
        gmiPrice,
        nrgPrice,
        apePrice,
        beraPrice,
        bonePrice,
        monPrice,
        coinPrice,
      }}
    >
      {children}
    </PriceContext.Provider>
  );
};
